import React, { useEffect } from 'react';

import { CanvasEventBoards } from '../components/canvas/canvas-event-boards';
import { CanvasStaticBoards } from '../components/canvas/canvas-static-boards';
import Joystick from '../components/joystick/joystick';
import supabase from '../../../core/supabase/supabase';
import useInitOverlay from '../hooks/initializers/use-init-overlay';
import { useFetchAvailableFeature } from 'shared/hooks/fetchering/use-fetch-available-feature';
import { useSelector } from 'react-redux';
import { selectOrganizer } from 'modules/stream/store/game-info/selectors';

function Overlay() {
  useInitOverlay();

  useEffect(() => {
    window.onerror = function (msg, url, line, col, error) {
      supabase.overlayLogs.createError({
        comment: 'overlay - общий',
        message: error?.stack ?? msg.toString(),
      });
    };
  }, []);

  const organizer = useSelector(selectOrganizer);
  const { data: feature, isFetching: isFeatureFetching } = useFetchAvailableFeature({ userTournamentId: organizer?.id });

  useEffect(() => {
    const rootDiv = document.getElementById('root');
    const body = document.getElementsByTagName('body')[0];
    rootDiv?.setAttribute('style', 'background: unset');
    body?.setAttribute('style', 'background: unset; overflow: hidden');
  }, []);

  if (!isFeatureFetching && !feature?.OBS_INTEGRATION) {
    return <h1>Подписка не активирована</h1>;
  }

  return (
    <div key={'overlay'} className={'d-flex justify-content-end'} style={{ width: '100%', height: '100vh' }}>
      <div
        className={'d-flex justify-content-end'}
        style={{
          background: 'unset',
          width: '100%',
          height: '100%',
          position: 'relative',
        }}
      >
        <CanvasStaticBoards />
        <CanvasEventBoards />
      </div>
      {feature?.OBS_INTEGRATION && <Joystick key={'FullSizeControlPanel-old'} />}
    </div>
  );
}

export default Overlay;
